<template>
  <base-view icon="layers" title="Fuentes de Financiamiento">
    <!-- Muestra el periodo fiscal activo -->
    <template #right-place>
      <div class="row">
        <x-periodo-fiscal-tag classBody="col-4 offset-8 right-content" variant="primary" />
      </div>
    </template>

    <!-- Form -->
    <check-authorization
      :requiresAuthorizations="[permissions.create]"
      :overrideIf="$store.getters['fuenteFinanciamientoModule/isEditingResource']"
      hide
    >
      <fuente-financiamiento-form
        ref="fuenteFinanciamientoForm"
        v-show="showForm || isEditingResource"
        @hide-form="showForm = false"
        @submitted="getListadoFuentesFinanciamiento"
      />
    </check-authorization>

    <!-- Listado -->
    <check-authorization :requiresAuthorizations="[permissions.list]">
      <div class="card card-header-actions">
        <div class="card-header">
          Listado de fuentes de financiamiento
          <x-btn-with-auth
            v-show="!showForm"
            :requiresAuthorizations="[permissions.create]"
            :callback="cancel"
            variant="success"
            btnClass="ml-auto"
          >
            {{ !showForm ? 'Crear' : 'Ocultar' }}
          </x-btn-with-auth>
        </div>
        <div class="card-body p-3">
          <fuente-financiamiento-list :permissions="permissions" @input="onChangePeriodoFiscal" />
        </div>
      </div>
    </check-authorization>
  </base-view>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import FuenteFinanciamientoForm from '@/components/Catalogos/FuentesFinanciamiento/FuenteFinanciamientoForm'
import FuenteFinanciamientoList from '@/components/Catalogos/FuentesFinanciamiento/FuenteFinanciamientoList'

export default {
  name: 'FuentesFinanciamientoView',

  components: {
    FuenteFinanciamientoForm,
    FuenteFinanciamientoList
  },

  computed: {
    ...mapState('fuenteFinanciamientoModule', ['isCretingResource']),
    ...mapGetters('fuenteFinanciamientoModule', ['isEditingResource', 'getCurrentEditing'])
  },

  created () {
    this.permissions = this.$router.currentRoute.meta.permissions
  },

  mounted () {
    this.$store.dispatch('fuenteFinanciamientoModule/resetState')
  },

  data () {
    return {
      showForm: false,
      periodo_fiscal_id: null,
      permissions: {}
    }
  },

  methods: {
    ...mapMutations('fuenteFinanciamientoModule', ['setCurrentResource']),
    ...mapActions('fuenteFinanciamientoModule', ['getAll']),

    async getListadoFuentesFinanciamiento () {
      const { error, message } = await this.getAll(this.periodo_fiscal_id)

      if (error) this.$notify({ error, message }, 'Listado de fuentes de financiamiento')
    },

    cancel () {
      this.showForm = !this.showForm
    },

    onChangePeriodoFiscal (periodo_fiscal_id) {
      this.periodo_fiscal_id = periodo_fiscal_id

      this.getListadoFuentesFinanciamiento()
    },

    onHideForm () {
      this.showForm = false
    }
  }
}
</script>
